define('viewmodels/VisualAnalytics/InherentHeatMapAnalysis',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'viewmodels/VisualAnalytics/VisualanalyticsThresholds', 'viewmodels/VisualAnalytics/VisualanalyticsRiskScores', 'viewmodels/VisualAnalytics/ControlSetup', 'viewmodels/VisualAnalytics/InherentWeightings', 'viewmodels/VisualAnalytics/ControlsWeightings', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, system, logger, Thresholds, RiskScores, ControlRiskScores, InherentWeightings, ControlsWeightings, utils, ObjGeneralSettings) {

        var ViewModel = {
            //Default Methods for Page starts here
            activate: activate,
            attached: attached,
            detached: detached,
            utils: utils,
            appsecurity: appsecurity,
            InherentWeightings: InherentWeightings,
            ControlsWeightings: ControlsWeightings,
            Thresholds: Thresholds,
            RiskScores: RiskScores,
            ControlRiskScores: ControlRiskScores,
            //Default Methods for Page Ends here

            //functions that are intialised on load
            GetAllBusinessUnits: GetAllBusinessUnits,
            InvokeDataCopy: InvokeDataCopy,
            AlterWeightings: AlterWeightings,//this will show pop up where you can alter weightings
            AlterThresholds: AlterThresholds,//this will show pop up in which you can alter thresholds
            AlterRiskScores: AlterRiskScores,
            ShowHeatmap: ShowHeatmap,//this method shows the heat map in the front end
            ExportReport: ExportReport,
            //onChnageofYearofAssessment: onChnageofYearofAssessment,//this Method handles change in year of assessment
            onChangeofAssessmentProfile: onChangeofAssessmentProfile,
            //function that are intialise on load ends here
            //variables for funtions that are intialised on load

            SelectedBuUnitsID: ko.observableArray([]),//this captures the selected option in multiselect dropdown
            AmlInhHeatMapData: ko.observableArray([]),
            AmlPredInhHeatMapData: ko.observableArray([]),
            YearOfAssessmentList: ko.observableArray([]),//this holds year of assessment dropdown details
            AmlInhHeatMapDataDup: ko.observableArray([]),
            AmlPredInhHeatMapDataDup: ko.observableArray([]),
            AmlInhRiskAreaList: ko.observableArray([]),
            AmlPredInhRiskAreaList: ko.observableArray([]),
            BussinessUnitList: ko.observableArray([]),//this captures the processsed json (i.e modeled businessunits data)
            SelectedYearOfAssessment: ko.observable('2021'),//this captures selected year of Assessment
            AssesmentType: ko.observable(),//this holds value of the selected Assessment Type
            WeightingsComparissionList: ko.observableArray([]),//holds changed weightings value
            ThresholdsComparissionList: ko.observableArray([]),//holds changed thresholds value
            RiskScoresComparissionList: ko.observableArray([]),
            QualThresholdsComparisonList: ko.observableArray([]),
            BusinessLevel: ko.observableArray(),
            BusinessLevelList: ko.observableArray([]),
            isFirst: ko.observable(0),
            CurrentYearOfAssessment: ko.observable(),
            ChangedWTBusinessUnits: ko.observableArray(["Risk Area Name", "Risk Factor Name", "Type"]),
            ProfileofAssessmentList: ko.observableArray(),
            ProfileName: ko.observable(),
            CurrentAssesmentProfile: ko.observable(),
            EnableExport: ko.observable(false),
            GetCurrentProfileOfAssessment: GetCurrentProfileOfAssessment,
            SelectedProfileOfAssessment: ko.observable(),
            AssessmentTypeList: ko.observableArray([]),
            GetAllAssessmentTypes: GetAllAssessmentTypes,
            onChangeofAssessmentType: onChangeofAssessmentType,
            AssessmentTypeName: ko.observable(),
            ProposedAssessmentTypeName: ko.observable(),
            AssessmentName: ko.observable(),
            SubAreaFlag: ko.observable(0),
            //variables for funtions that are intialised on load end here

            // Added functions
            AddComparisonScenario: AddComparisonScenario,
            EditComparisonScenario: EditComparisonScenario,
            CreateScenario: CreateScenario,
            DeleteScenario: DeleteScenario,
            EditScenario: EditScenario,
            getScenarioDetails: getScenarioDetails,
            ScenarioModel: ScenarioModel,
            ScenarioList: ko.observableArray([]),
            EditFlag: ko.observable(0),
            ClearScenarioForm: ClearScenarioForm,
            SelectedScenarioId: ko.observable(''),
            SelectedAssessmentType: ko.observable(),
            ThresholdsCloseModal: ThresholdsCloseModal,
            SurveyCategoryList: ko.observableArray([]),
            GetSurveyCategoryList: GetSurveyCategoryList,
            SelectedGroupName: ko.observable(),

            SelectedStatus: ko.observable(),
            selectedIds: ko.observableArray([]),
            RunSimulation: RunSimulation,
            DeleteScenarioPopUp: DeleteScenarioPopUp,
            ReportsTabClick: ReportsTabClick,
            ScenarioTabClick: ScenarioTabClick,
            ShowReport: ShowReport,
            GetUser: GetUser,
            User: ko.observable(),

            ObjGeneralSettings: ObjGeneralSettings,
            LocaleCheckFlag: ko.observable(false),
            ScenarioPopupTitle: ko.observable(),
            AlterWeightingPopup: AlterWeightingPopup,
            AlterThresholdsPopup: AlterThresholdsPopup,
            AlterRiskScoresPopup: AlterRiskScoresPopup,
            ChangeApplicability: ChangeApplicability

            //DisplayReport: ko.observable(false)
        };
        return ViewModel;

        var UserTableObj = false;



        function activate() {
            try {

                if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            ViewModel.LocaleCheckFlag(false);
                        else
                            ViewModel.LocaleCheckFlag(true);
                    });
                } else
                    ViewModel.LocaleCheckFlag(true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                ViewModel.isFirst(0)
                $('#BUSelector').multiselect();
                $('#error').show();
                $($(document.getElementsByClassName('list-group-item')).get(0)).addClass('active');
                $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).addClass('active');
                //GetCurrentYearOfAssessment().then(function () {
                GetProfileAssessments().then(function () {
                    ViewModel.appsecurity.GetCurrentProfileOfAssessment().then(function () {
                        ViewModel.SelectedProfileOfAssessment(ViewModel.appsecurity.CurrentProfileOfAssessmentId())
                        GetAllAssessmentTypes();
                            //.then(function () {
                            //GetAllYearsOfAssessment().then(function () {
                            //InvokeDataCopy().then(function () {
/*                            GetSubAreaFlag();*/
                            //    .then(function () {
                            //    GetAllBusinessUnits();
                            //    //})
                            //})
                        //})
                    })
                });
                GetUser();
                getScenarioDetails();
                $('#WIA_tabs li:first a:first').click();

                if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            ViewModel.LocaleCheckFlag(false);
                        else
                            ViewModel.LocaleCheckFlag(true);
                    });
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function detached() {
            try {
                ViewModel.isFirst(0);
                ViewModel.SelectedProfileOfAssessment(null);
                ViewModel.ProfileofAssessmentList([]);

                $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        };
        function GetCurrentProfileOfAssessment() {
            try {
                return $.ajax({
                    url: "/api/Reporting/GetCurrentProfileOfAssessment",
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetCurrentProfileOfAssessment() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult >= 0) {
                        ViewModel.CurrentAssesmentProfile(jsonResult);
                        ViewModel.SelectedProfileOfAssessment(ViewModel.CurrentAssesmentProfile());
                    }
                    else {
                        logger.logError('An error occurred while fetching the current Year of Assessment. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetCurrentYearOfAssessment() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllYearsOfAssessment() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetCurrentYearOfAssessment() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }



        }
        //..........................................This method invokes copy of data from actual tables to temp table starts here..................................................


        function ScenarioTabClick() {
            $('#ScenarioTab').show();
            $('#ReportsTab').hide();
            $('#btnAddScenario').show();
            $('#WIA_tabs li').removeClass('active');
            $('#Scenarios_WIA').addClass('active');
            getScenarioDetails();
        }


        function ReportsTabClick() {
            $('#ReportsTab').show();
            $('#ScenarioTab').hide();
            $('#btnAddScenario').hide();
            $('#WIA_tabs li').removeClass('active');
            $('#Reports_WIA').addClass('active');
            ShowReport();
        }

        function GetUser() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Reporting/GetUser",
                    type: "GET",
                    headers: headers,

                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult.ReportId != -999) {

                        ViewModel.User(jsonResult);
                        loadFindingReport();
                    }
                    else {
                        logger.logError(jsonResult.ReportComments + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(ReportViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUser() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUser() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            };
        }


        function ShowReport(data) {
            try {
                //ViewModel.PageHeader('Reports: ');
                $('#divReport').html('');
                var homeurl = homeUrlLocation;
                var url = window.location.hash;
                $('<iframe>', {

                    src: homeurl + 'SSRSWIAReport.aspx?ReportName=' + "RPT_WIA_Report" + '&UserId=' + ViewModel.User(),
                    id: 'iframe_FINDINGS',
                    frameborder: 0,
                    style: 'display: block; width: 100%; height: 1500px; margin-left: 0px;',
                }).appendTo('#divReport');

                $('#div_DisplayReport').show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function GetSurveyCategoryList() {
            try {
                $.ajax({
                    url: "/api/Visualization/GetSurveyCategoryTabsByAssessmentType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": ViewModel.SelectedAssessmentType() }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult != null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                ViewModel.SurveyCategoryList(mappedTabList);

                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in InherentHeatMapAnalysis.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentHeatMapAnalysis.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }



        function ClearScenarioForm() {
            //$("#AddScenario").toggle();
            ViewModel.EditFlag(0);
            document.getElementById('scenarioName').value = "";
            document.getElementById('scenarioDescription').value = "";
        }

        function AddComparisonScenario() {
            ViewModel.EditFlag(0);
            ViewModel.ScenarioPopupTitle("Add Comparison Scenario");
            document.getElementById('scenarioName').value = "";
            document.getElementById('scenarioDescription').value = "";
            //$("#AddScenario").toggle();
            $("#frmAddEditScenario").modal('show');
        }

        function EditComparisonScenario(data) {
            // Reusing the add comparison scenario

            ViewModel.EditFlag(1);
            ViewModel.ScenarioPopupTitle("Edit Comparison Scenario");
            //$("#AddScenario").toggle();
            //var SelectedScenarioId = data.ScenarioId();
            ViewModel.SelectedScenarioId(data.ScenarioId());
            ViewModel.SelectedAssessmentType(data.AssessmentType());
            //ViewModel.SelectedAssessmentType(ViewModel.AssesmentType());
            ViewModel.AssesmentType(data.AssessmentType());

            document.getElementById('scenarioName').value = data.ScenarioName();
            document.getElementById('scenarioDescription').value = data.ScenarioDescription();

            GetSurveyCategoryList(); // This will give us the list to pre-populate the state dropdown
            $("#frmAddEditScenario").modal('show');
            //EditScenario(data);
        }

        function CreateScenario(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                var ScenarioName = document.getElementById('scenarioName').value || "";
                var ScenarioDescription = document.getElementById('scenarioDescription').value || "";
                // Selected Assessment Type ViewModel.AssesmentType();

                if (ViewModel.ScenarioList().length >= 3) {
                    logger.logError(
                        //'You have reached the maximum Scenario Creation Limit'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaximumScenarioLimit') == -1) ? 'You have reached the maximum Scenario Creation Limit' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaximumScenarioLimit')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                    throw new Error(
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaximumScenarioLimit') == -1) ? 'You have reached the maximum Scenario Creation Limit' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MaximumScenarioLimit')].Name()
                        //"Scenario Already Exists"
                    );
                }

                if (ScenarioName == "" || ScenarioDescription == "" || ScenarioName == " " || ScenarioDescription == " ") {
                    logger.logError(
                        //'Please Enter all Details'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterAllDetailsValidation') == -1) ? 'Please Enter all Details' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterAllDetailsValidation')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                    throw new Error(
                        //"Please Enter all Details"
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterAllDetailsValidation') == -1) ? 'Please Enter all Details' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EnterAllDetailsValidation')].Name()
                    );
                }

                for (var i = 0; i < ViewModel.ScenarioList().length; i++) {
                    if (ScenarioName == ViewModel.ScenarioList()[i].ScenarioName()) {
                        logger.logError(
                            //'A scenario with same name already exists'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioNameValidation') == -1) ? 'A scenario with same name already exists' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioNameValidation')].Name()
                            , 'Error', system.getModuleId(ViewModel), true);
                        throw new Error(
                            //"Scenario Already Exists"
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioNameValidation') == -1) ? 'A scenario with same name already exists' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioNameValidation')].Name()
                        );
                    }
                }


                $.ajax({
                    url: "/api/Visualization/CreateScenario?AssessmentType=" + ViewModel.AssesmentType().toString() + "&ScenarioName=" + ScenarioName + "&ScenarioDescription=" + ScenarioDescription,
                    headers: headers,
                    type: "POST",
                    //data: { AssessmentType: ViewModel.AssesmentType().toString(), ScenarioName: ScenarioName, ScenarioDescription: ScenarioDescription },
                    contentType: 'application/json',
                    dataType: "json"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from CreateScenario() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult >= 1) {
                        logger.logSuccess(
                            //'Scenario has been created successfully.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationSuccess') == -1) ? 'Scenario has been created successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationSuccess')].Name()
                            , 'Success', system.getModuleId(ViewModel), true);
                        // We get the value of Last Scenario Id as JsonResult
                        // Now we will invoke the data copy over
                        InvokeDataCopy(jsonResult);

                        getScenarioDetails();
                        //we will place here the get scenarios call;

                        //$("#AddScenario").toggle();
                        document.getElementById('scenarioName').value = "";
                        document.getElementById('scenarioDescription').value = "";
                    }
                    else
                        logger.logError(
                            //'An error occurred while creating new scenario. Please contact your Administrator.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationError') == -1) ? 'An error occurred while creating new scenario. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationError')].Name()
                            , 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CreateScenario() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateScenario() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from CreateScenario() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }

        function DeleteScenarioPopUp(data, event) {
            try {
                app.showMessage(
                    //"Are you sure you want to Delete this Scenario?"
                    (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteScenarioConfirmation') == -1) ? 'Are you sure you want to Delete this Scenario?' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteScenarioConfirmation')].Name()
                    , (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteScenarioLabel') == -1) ? 'Delete Scenario' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteScenarioLabel')].Name()
                    //"Delete Scenario"
                    , [
                        //"Confirm"
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()
                        ,
                        //"Cancel"
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name()
                    ], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    //app.showMessage('Are you sure you want to Delete this Scenario?', ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                    .then(function (option) {
                        if (option === ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name())) {
                            DeleteScenario(data, event);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowDeletePopUp() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function DeleteScenario(data, event) {
            try {
                csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/DeleteScenario?ScenarioId=" + data.ScenarioId() + "&AssessmentType=" + parseInt(data.AssessmentType()),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteRole() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult == 1) {
                        logger.logSuccess(
                            //'Scenario deleted successfully.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioDeleteSuccess') == -1) ? 'Scenario deleted successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioDeleteSuccess')].Name()
                            , 'Success', system.getModuleId(ViewModel), true);
                        getScenarioDetails();
                    }
                    else
                        logger.logError(
                            //'An error occurred while deleting the Scenario. Please contact your Administrator'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioDeleteError') == -1) ? 'An error occurred while deleting the Scenario. Please contact your Administrator' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioDeleteError')].Name()
                            , 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in Delete Scenario() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteRole() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteRole() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            };
        }


        function EditScenario(data, event) {
            try {

                //$("#AddScenario").hide();
                //ViewModel.EditFlag(0);
                //document.getElementById('scenarioName').value = "";
                //document.getElementById('scenarioDescription').value = "";

                var ScenarioId = parseInt(ViewModel.SelectedScenarioId());

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                var ScenarioName = document.getElementById('scenarioName').value || "";
                var ScenarioDescription = document.getElementById('scenarioDescription').value || "";
                // Selected Assessment Type ViewModel.AssesmentType();

                /*
                 * Allow users to alter weightings and thresholds
                 */

                if (ScenarioName == "" || ScenarioDescription == "" || ScenarioName == " " || ScenarioDescription == " ") {
                    throw new Error("Please Enter all Details");
                }

                for (var i = 0; i < ViewModel.ScenarioList().length; i++) {
                    if (ScenarioId != ViewModel.ScenarioList()[i].ScenarioId() && ScenarioName == ViewModel.ScenarioList()[i].ScenarioName() && (ViewModel.SelectedAssessmentType() == ViewModel.AssesmentType())) {
                        logger.logError('A scenario with same name already exists', 'Error', system.getModuleId(ViewModel), true);
                        throw new Error("Scenario Already Exists");
                    }
                }

                //var StateSelected = ViewModel.SelectedStatus().SurveyCategoryName();

                $.ajax({
                    url: "/api/Visualization/EditScenario?AssessmentType=" + ViewModel.AssesmentType().toString() + "&ScenarioName=" + ScenarioName + "&ScenarioDescription=" + ScenarioDescription + "&ScenarioId=" + ScenarioId,
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: "json"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from EditScenario() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult >= 1) {
                        logger.logSuccess('Scenario has been updated successfully.', 'Success', system.getModuleId(ViewModel), true);
                        InvokeDataCopy(parseInt(ViewModel.SelectedScenarioId()));
                        getScenarioDetails();
                        //ClearScenarioForm();
                    }
                    else
                        logger.logError(
                            //'An error occurred while creating new scenario. Please contact your Administrator.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationError') == -1) ? 'An error occurred while creating new scenario. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ScenarioCreationError')].Name()
                            , 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from EditScenario() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation.",
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in EditScenario() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from CreateScenario() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }

        function RunSimulation(data, event) {
            try {
                //var ScenarioId = parseInt(ViewModel.SelectedScenarioId());
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                var ScenarioIds = "";
                if (ViewModel.ScenarioList().length > 0) {
                    for (var i = 0; i < ViewModel.ScenarioList().length; i++) {
                        if (ViewModel.ScenarioList()[i].isChecked()) {
                            if (ScenarioIds === "")
                                ScenarioIds = ViewModel.ScenarioList()[i].ScenarioId().toString();
                            else
                                ScenarioIds += "," + ViewModel.ScenarioList()[i].ScenarioId().toString();
                        }
                    }
                }
                if (ScenarioIds === "") {
                    logger.logError('No scenarios have been selected.', 'Error', system.getModuleId(ViewModel), true);
                    return;
                }
                

                //if (ViewModel.selectedIds().length > 0) {
                //    for (var i = 0; i < ViewModel.selectedIds().length; i++) {
                //        if (ScenarioIds === "")
                //            ScenarioIds = ViewModel.selectedIds()[i].toString();
                //        else
                //            ScenarioIds += "," + ViewModel.selectedIds()[i].toString();
                //    }
                //}

                $.ajax({
                    url: "/api/Visualization/RunSimulationCalculations?ScenarioIds=" + ScenarioIds.toString() + "&ProfileId=" + appsecurity.CurrentProfileOfAssessmentId(),
                    type: "POST",
                    headers: headers,
                    //data: ScenarioIds
                    contentType: 'application/json',
                    dataType: "json"
                }).success(function (result) {
                    if (result >= 1) {
                        logger.logSuccess('Calculations have been initiated successfully. Please refresh to know the status.', 'Success', system.getModuleId(ViewModel), true);
                        getScenarioDetails();
                    }
                    else if (result == 0 || result == -1) {
                        logger.logError('An error has occurred while running the calculations. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                }).fail(function () {
                });
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from EditScenario() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }


        function getScenarioDetails() {
            try {
                $.ajax({
                    url: "/api/Visualization/GetScenario", // Update it
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getScenarioDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    //if (jsonResult.length > 0) {
                    var MappedScenarioDetails = $.map(jsonResult, function (result) {
                        return new ScenarioModel(result);
                    });

                    tableObj = $('#tblScenarioDetails').DataTable();
                    tableObj.destroy();
                    $('#tblScenarioDetails tbody tr').remove();
                    QuestionTableObj = undefined;
                    ViewModel.ScenarioList([]);
                    ViewModel.ScenarioList(MappedScenarioDetails)

                    $('#MultiSelectSimulations').multiselect();
                    $('#MultiSelectSimulations').multiselect("refresh");
                    if (ViewModel.ScenarioList().length === 0)
                        $("#MultiSelectSimulations").hide();


                    QuestionTableObj = $('#tblScenarioDetails').DataTable({
                        "order": [],
                        "aaSorting": [],
                        "bResponsive": true,
                        //"fnRowCallback": function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        //    if (aData[0] == ViewModel.CurrentYear()) {
                        //        $('td', nRow).css('background-color', '#CCE5FF');
                        //    }
                        //}

                    });

                    $('#tblScenarioDetails').DataTable().draw(false);
                    //}
                    //else
                    //    logger.logError('An error occurred while fetching the Scenario Details. Please contact your application administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getScenarioDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getScenarioDetails() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from getScenarioDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

        }

        function ThresholdsCloseModal() {
            $('#ThresholdsPopUp').hide();
        }


        function InvokeDataCopy(ScenarioId) {
            try {
                try {
                    var options = {
                        url: "/api/Visualization/InvokeCopy?ScenarioId=" + ScenarioId,
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    };
                    return $.ajax(options)
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in InvokeDataCopy() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
                function ajaxSuccess(jsonResultObj, status) {

                    try {

                        if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {

                        }
                        else {
                            //app.showMessage("Business Units configurations not in place", "Error", [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)]);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in InvokeDataCopy() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }

                };
                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InvokeDataCopy() method in InherentHeatMapAnalysis.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in InvokeDataCopy() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Methodcall in InvokeDataCopy() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        //..........................................This method invokes copy of data from actual tables to temp table ends here..................................................

        //.......................................This Method populates the multiselect dropdown for business units..................................................//

        function GetAllBusinessUnits(options) {
            try {
                var options = {
                    url: "/api/Reporting/GetAllBusinessUnitsByProfileofAssessment?ProfileOfAssessment=" + ViewModel.SelectedProfileOfAssessment(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                };
                return $.ajax(options)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnits() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResultObj, status) {

                try {
                    if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                        var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                            return new BusinessUnitsModel(result);
                        });
                        $('#BULoadingImgDiv').hide();
                        ViewModel.BussinessUnitList(mappedBusinessUnits);
                        $('#BUSelector').multiselect("refresh");
                        $('#BUSelector').multiselect();
                        //$(".ui-multiselect-checkboxes > li > label").addClass("cc-checkbox");
                        $(".ui-multiselect-checkboxes > li > label > span").addClass("cc-facet-result-text tag-text");
                    }
                    else {
                        ViewModel.BussinessUnitList([]);
                        ViewModel.SelectedBuUnitsID([]);
                        $('#BUSelector').multiselect("refresh");
                        app.showMessage("Business Units configurations not in place", "Error", [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)]);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnits() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }

            };
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            };
        };

        //ASSESSMENTTYPE
        //Function to bind the applicability Dropdown Dynamically starts here
        function GetAllAssessmentTypes() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetAssessmentTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        ViewModel.AssessmentTypeList([]);
                        if (jsonResult != null) {


                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                            ViewModel.AssessmentTypeList(MappedAssessmentList);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError(
                            //'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                            , 'Error', system.getModuleId(ViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskAreasfactors.js';
                logger.logMessage(msg);
            }
        }
        //aSSESSMENTTYPE


        //Method that gets invoked on change of year of assessment starts here
        //function onChnageofYearofAssessment() {
        //    try {
        //        if (ViewModel.SelectedBuUnitsID().length == 0) {
        //            $('#error').show();
        //        } else {
        //            $('#error').hide();

        //        }
        //        if (ViewModel.isFirst() == 1) {
        //            GetAllBusinessUnits();
        //            InvokeDataCopy();
        //        }
        //        else {
        //            ViewModel.isFirst(1)

        //        }
        //    }
        //    catch (e) {
        //        var msg = 'Exception: ' + e + ' | Source: Methodcall in onChnageofYearofAssessment() method in InherentHeatMapAnalysis.js';
        //        logger.logMessage(msg);
        //    }
        //}
        //Method that gets invoked on change of year of assessment ends here

        function onChangeofAssessmentProfile() {
            try {
                if (ViewModel.SelectedBuUnitsID().length == 0) {
                    $('#error').show();
                } else {
                    $('#error').hide();

                }
                if (ViewModel.isFirst() == 1) {
                    GetAllBusinessUnits();
                    InvokeDataCopy();
                    GetSubAreaFlag();
                }
                else {
                    ViewModel.isFirst(1)

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Methodcall in onChangeofAssessmentProfile() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function onChangeofAssessmentType(data, event) {
            try {
                for (var i = 0; i < data.AssessmentTypeList().length; i++) {
                    if (ViewModel.AssesmentType() == data.AssessmentTypeList()[i].AssessmentId()) {
                        ViewModel.ProposedAssessmentTypeName('Proposed ' + data.AssessmentTypeList()[i].AssessmentName() + ' Inherent Risk HeatMap');
                        ViewModel.AssessmentTypeName(data.AssessmentTypeList()[i].AssessmentName() + ' Inherent Risk HeatMap');
                        ViewModel.AssessmentName(data.AssessmentTypeList()[i].AssessmentName());

                    }

                    ViewModel.SelectedAssessmentType(parseInt(ViewModel.AssesmentType()));
                    GetSurveyCategoryList();

                }




            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Methodcall in onChangeofAssessmentProfile() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function GetProfileAssessments() {
            try {
                return $.ajax({
                    url: "/api/Reporting/GetProfileAssessmentData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetProfileAssessments() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0) {
                        var MappedPeriodofAssessment = $.map(jsonResult, function (result) {
                            return new ProfileofAssessmentModel(result);
                        });
                        ViewModel.ProfileofAssessmentList([]);
                        ViewModel.ProfileofAssessmentList(MappedPeriodofAssessment);


                    }
                    else
                        logger.logError('An error occurred while fetching the Current Profile of Assessment. Please contact your application administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetProfileAssessments() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAssessmentProfileDetails() method in YearSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetProfileAssessments() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }

        //Method that shows all the year of assessment details ends here


        //------------------------------------------This Method shows the popup for weightings starts here-------------------------------------------------------------------------------------//
        function AlterWeightingPopup(data) {
            ViewModel.SelectedScenarioId(data.ScenarioId());
            ViewModel.AssesmentType(data.AssessmentType());
            $('#frmAlter').modal('show');
            AlterWeightings();
        }
        function AlterWeightings() {
            try {
                $('#Edit-tabs li').removeClass('active');
                $('#Alter_Weights_WIA').addClass('active');
                $('#AlterThresholds_WIA').hide();
                $('#AlterRiskScores_WIA').hide();
                $('#AlterWeights_WIA').show();
                var StateSelected = ViewModel.SelectedStatus().SurveyCategoryId(); // Inherent/Controls Determination
               

                //$('#risk-scores-parameters').hide();
                //$('#parameters').hide();
                //$('#weightings-parameters').show();
                
                ViewModel.SelectedGroupName(ViewModel.SelectedStatus().SurveyGroupShortName());
                
                if (ViewModel.SelectedStatus().SurveyGroupShortName() == "CDR") {
                    ViewModel.ControlsWeightings.GetSurveyCategoryTabsCW(ViewModel.AssesmentType(), ViewModel.SelectedScenarioId(), StateSelected);
                }
                else {
                    ViewModel.InherentWeightings.GetSurveyCategoryTabs(ViewModel.AssesmentType(), ViewModel.SelectedScenarioId(), StateSelected);
                }
                //ViewModel.weightings.GetAllRiskAreas(ViewModel.AssesmentType(), ViewModel.AssessmentName(), StateSelected, ViewModel.SelectedScenarioId(), ViewModel.SelectedStatus().SurveyGroupShortName());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AlterWeightings() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------------------This Method shows the popup for weightings ends here-------------------------------------------------------------------------------------//

        //-------------- method which shows the popup in which you can alter weightings starts here---------------------------------------------
        function AlterThresholdsPopup(data) {
            ViewModel.SelectedScenarioId(data.ScenarioId());
            ViewModel.AssesmentType(data.AssessmentType());
            $('#frmAlter').modal('show');
            AlterThresholds();
        }

        function AlterThresholds() {
            try {
                $('#Edit-tabs li').removeClass('active');
                $('#Alter_Thresholds_WIA').addClass('active');              
                $('#AlterRiskScores_WIA').hide();
                $('#AlterWeights_WIA').hide();
                $('#AlterThresholds_WIA').show();

                var StateSelected = ViewModel.SelectedStatus().SurveyCategoryId();
                //$('#ThresholdsPopUp').show();

                //$('#risk-scores-parameters').hide();
                //$('#weightings-parameters').hide();
                //$('#parameters').show();
                ViewModel.Thresholds.pageinvoke(ViewModel.AssesmentType(), ViewModel.AssessmentName(), StateSelected, ViewModel.SelectedScenarioId(), ViewModel.SelectedStatus().SurveyGroupShortName());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AlterThresholds() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        //-------------method which shows the popup in which you can alter weightings ends here
        
        function AlterRiskScoresPopup(data) {
            ViewModel.SelectedScenarioId(data.ScenarioId());
            ViewModel.AssesmentType(data.AssessmentType());
            $('#frmAlter').modal('show');
            AlterRiskScores();
        }
        function AlterRiskScores() {
            try {
                $('#Edit-tabs li').removeClass('active');
                $('#Alter_RiskScores_WIA').addClass('active');
                
                $('#AlterWeights_WIA').hide();
                $('#AlterThresholds_WIA').hide();
                $('#AlterRiskScores_WIA').show();
                ViewModel.SelectedGroupName(ViewModel.SelectedStatus().SurveyGroupShortName());

                var StateSelected = ViewModel.SelectedStatus().SurveyCategoryId();

                //$('#parameters').hide();
                //$('#weightings-parameters').hide();

                //$('#risk-scores-parameters').show();

                if (ViewModel.SelectedStatus().SurveyGroupShortName() != "CDR") {
                    ViewModel.RiskScores.GetSurveyCategoryTabsRs(ViewModel.AssesmentType(), StateSelected, ViewModel.SelectedScenarioId());
                }
                else {
                    ViewModel.ControlRiskScores.GetSurveyCategoryControlTabsCS(ViewModel.AssesmentType(), StateSelected, ViewModel.SelectedScenarioId());
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AlterThresholds() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function ChangeApplicability(data) {
            var a = 1;
        }

        //------------------function that gets called on click on show heatmap button starts here----------------------------------------------
        function ShowHeatmap() {

            try {
                if (ViewModel.SelectedBuUnitsID().length == 0) {
                    $('#error').show();
                } else {
                    $('#error').hide();
                    RunRiskengine();
                    // GetWeightingsComparissionDetails();
                }
                ViewModel.EnableExport(true);
            }
            catch (e) {
                var msg = 'exception' + e + 'source in ShowHeatmap() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }


        function ExportReport() {

            try {

                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), json: JSON.stringify($.map(ViewModel.SelectedBuUnitsID(), function (result) { return { BuId: result }; })), AssessmentProfile: ViewModel.SelectedProfileOfAssessment(), AssessmentType: ViewModel.AssesmentType()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportHeatMapReport", payLoad, '_blank');

            }
            catch (e) {
                var msg = 'exception' + e + 'source in ExportReport() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        //------------------function that gets called on click on show heatmap button ends here------------------------------------------------
        //--------------------------------------Method which shows the Actual heat map starts here--------------------------------------
        function getInhHeatMapData() {
            try {
                $('#loadingMainImgInhDiv').show();
                $('#loadingMainImgInh').show();
                $('#InherentHeatMapDiv').hide();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/GetInherentHeatMapFilteredData?Profile=" + ViewModel.SelectedProfileOfAssessment() + "&AssessmentType=" + ViewModel.AssesmentType() + "&BusinessLevel=" + ViewModel.BusinessLevel(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify($.map(ViewModel.SelectedBuUnitsID(), function (result) {
                        return { BuId: result };

                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#loadingMainImgInhDiv').hide();
                    //$('#InherentHeatMapDiv').show();
                    $('#tblInhHeatMap tbody tr').remove();
                    ViewModel.AmlInhHeatMapData([]);
                    if (jsonResult != null && jsonResult.length > 0) {
                        var NewJsonResult = [];
                        var NewJsonResultDup = [];
                        var NewAreaObj = [];
                        var NewAreaObjDup = [];
                        for (var i = 0; i < jsonResult[0].RiskAreas.length; i++) {
                            NewAreaObj[i] = { RaId: jsonResult[0].RiskAreas[i].RaId, RaName: jsonResult[0].RiskAreas[i].RaName, RiskLevel: jsonResult[0].RiskAreas[i].RaName, Css: "" };
                        }

                        NewJsonResult[0] = { BuId: -1, BuName: "Risk Areas/Business Unit", CalcRiskLevel: "", CalcRiskLevelCss: "", OverriddenRiskLevel: "", OverriddenRiskLevelCss: "", FinalRiskLevel: "", FinalRiskLevelCss: "", RiskAreas: NewAreaObj };

                        for (var i = 0; i < jsonResult.length; i++) {
                            NewJsonResult[i + 1] = jsonResult[i];
                        }

                        var mappedAmlHeatMapData = $.map(NewJsonResult, function (result) {
                            return new BusinessUnitModel(result);
                        })

                        ViewModel.AmlInhHeatMapData(mappedAmlHeatMapData);
                        ViewModel.AmlInhRiskAreaList(ViewModel.AmlInhHeatMapData()[0].AreaList());

                        //Logic for Keeping a duplicate copy of the Heat Map Data for later logics
                        for (var i = 0; i < jsonResult[0].RiskAreas.length; i++) {
                            NewAreaObjDup[i] = { RaId: jsonResult[0].RiskAreas[i].RaId, RaName: jsonResult[0].RiskAreas[i].RaName, RiskLevel: jsonResult[0].RiskAreas[i].RaName, Css: "" };
                        }

                        NewJsonResultDup[0] = { BuId: -1, BuName: "Risk Areas/Business Unit", CalcRiskLevel: "", CalcRiskLevelCss: "", OverriddenRiskLevel: "", OverriddenRiskLevelCss: "", FinalRiskLevel: "", FinalRiskLevelCss: "", RiskAreas: NewAreaObjDup };

                        for (var i = 0; i < jsonResult.length; i++) {
                            NewJsonResultDup[i + 1] = jsonResult[i];
                        }

                        var mappedAmlHeatMapDataDup = $.map(NewJsonResultDup, function (result) {
                            return new BusinessUnitModel(result);
                        })
                        ViewModel.AmlInhHeatMapDataDup(mappedAmlHeatMapDataDup);
                        FormatInhRows();
                        //
                    }
                    else if (jsonResult == null)
                        logger.logError('An error occurred while fetching Inherent Heat Map Data. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);

                    else {
                        logger.logError('No Inherent Heatmap data available for selected filter criteria.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    $('#InherentHeatMapDiv').show();

                    $("#innerdiv-actualheatmap").scroll(function () {
                        $("#innerdiv-predheatmap").scrollLeft($("#innerdiv-actualheatmap").scrollLeft())
                    });

                    $("#innerdiv-predheatmap").scroll(function () {
                        $("#innerdiv-actualheatmap").scrollLeft($("#innerdiv-predheatmap").scrollLeft())
                    });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }

        function FormatInhRows() {
            try {
                var NoOfRows = ViewModel.AmlInhRiskAreaList().length;
                var FinalRowIndex = (NoOfRows - 1);
                var OverrideRowIndex = (NoOfRows - 2);
                var CalcRowIndex = (NoOfRows - 3);
                $($($('#tblInhHeatMap tbody').find('tr').get(CalcRowIndex)).find('td').get(0)).addClass('label-info');
                $($($('#tblInhHeatMap tbody').find('tr').get(OverrideRowIndex)).find('td').get(0)).addClass('label-green ');
                $($($('#tblInhHeatMap tbody').find('tr').get(FinalRowIndex)).find('td').get(0)).addClass('label-info');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FormatInhRows() method in HeatMaps.js';
                logger.logMessage(msg);
            }
        }



        function InhCellMouseOverEvent(data, event) {
            try {
                //if ($('#tblInhHeatMap tbody').find(event.currentTarget).index() == 0)
                //    $(event.currentTarget).tooltip('show');
                //else
                $(event.currentTarget).css('cursor', 'default');
            }
            catch (e) {
                var msg = 'exception' + e + 'source in InhCellMouseOverEvent() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        //--------------------------------------Method which shows the Actual heat map ends here----------------------------------------


        //function RunRiskengine() {
        //    GetBusinessLevel().then(function () {
        //                                getInhHeatMapData();
        //                                GetPredictedHeatmapData();
        //                            })

        //                            GetWeightingsComparissionDetails().then(function () {
        //                                GetThresholdsComparissionDetails();
        //                            });



        //}




        //----------------------------Method that runs the calculation engine starts here------------------------------
        function RunRiskengine() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/RunRiskEngine?Profile=" + ViewModel.SelectedProfileOfAssessment() + "&AssessmentType=" + ViewModel.AssesmentType(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify($.map(ViewModel.SelectedBuUnitsID(), function (result) {
                        return { BuId: result };

                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in RunRiskengine() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null && jsonResult == 1) {
                        GetBusinessLevel().then(function () {
                            getInhHeatMapData();
                            GetPredictedHeatmapData();
                        })

                        GetWeightingsComparissionDetails().then(function () {
                            GetQualThresholdsComparisonDetails().then(function () {

                                GetThresholdsComparissionDetails().then(function () {
                                    GetRiskScoresComparissionDetails().then(function () { $('#CompareRiskScores').show(); })
                                });
                            });
                        });

                    }
                    else if (jsonResult == null)
                        logger.logError('An error occurred while running calculation engine. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);


                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in RunRiskengine() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RunRiskengine() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in RunRiskengine() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }

        //----------------------------Method that runs the calculation engine ends here--------------------------------
        //-------Mehtod to pull Bu level Heatmap Id's
        function GetBusinessLevel() {

            try {
                return $.ajax({
                    url: "/api/Configuration/getAllBusinessUnitLevels?type=" + ViewModel.AssesmentType() + "&Page_Type=IH",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            } catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajax call in GetBusinessLevel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        ViewModel.BusinessLevel(jsonResult.length);
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            var BusinessLevelModelObj = new BusinessLevelModel(result);
                            return BusinessLevelModelObj;
                        });

                        ViewModel.BusinessLevelList(MappedBUModelList);
                    }
                    else
                        logger.logError(
                            //'An error occurred. Please contact your Application Administrator.'
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name())
                            , 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetBusinessLevel() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {

                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBusinessLevel() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBusinessLevel() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

        }
        //-----------method to pull bulevel heatmap id's
        //------------------------------Method that shows the predictive heatmap starts here----------------------------------
        function GetPredictedHeatmapData() {
            try {
                $('#loadingMainImgPredInhDiv').show();
                $('#loadingMainImgPredInh').show();

                $('#PredInherentHeatMapDiv').hide();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/GetPredictiveInherentHeatMapFilteredData?Profile=" + ViewModel.SelectedProfileOfAssessment() + "&AssessmentType=" + ViewModel.AssesmentType() + "&BusinessLevel=" + ViewModel.BusinessLevel(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    data: JSON.stringify($.map(ViewModel.SelectedBuUnitsID(), function (result) {
                        return { BuId: result };

                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#loadingMainImgPredInhDiv').hide();
                    //$('#InherentHeatMapDiv').show();
                    $('#tblPredInhHeatMap tbody tr').remove();
                    ViewModel.AmlPredInhHeatMapData([]);
                    if (jsonResult != null && jsonResult.length > 0) {
                        var NewJsonResult = [];
                        var NewJsonResultDup = [];
                        var NewAreaObj = [];
                        var NewAreaObjDup = [];
                        for (var i = 0; i < jsonResult[0].RiskAreas.length; i++) {
                            NewAreaObj[i] = { RaId: jsonResult[0].RiskAreas[i].RaId, RaName: jsonResult[0].RiskAreas[i].RaName, RiskLevel: jsonResult[0].RiskAreas[i].RaName, Css: "" };
                        }

                        NewJsonResult[0] = { BuId: -1, BuName: "Risk Areas/Business Unit", CalcRiskLevel: "", CalcRiskLevelCss: "", OverriddenRiskLevel: "", OverriddenRiskLevelCss: "", FinalRiskLevel: "", FinalRiskLevelCss: "", RiskAreas: NewAreaObj };

                        for (var i = 0; i < jsonResult.length; i++) {
                            NewJsonResult[i + 1] = jsonResult[i];
                        }

                        var mappedAmlHeatMapData = $.map(NewJsonResult, function (result) {
                            return new BusinessUnitModel(result);
                        })

                        ViewModel.AmlPredInhHeatMapData(mappedAmlHeatMapData);
                        ViewModel.AmlPredInhRiskAreaList(ViewModel.AmlPredInhHeatMapData()[0].AreaList());

                        //Logic for Keeping a duplicate copy of the Heat Map Data for later logics
                        for (var i = 0; i < jsonResult[0].RiskAreas.length; i++) {
                            NewAreaObjDup[i] = { RaId: jsonResult[0].RiskAreas[i].RaId, RaName: jsonResult[0].RiskAreas[i].RaName, RiskLevel: jsonResult[0].RiskAreas[i].RaName, Css: "" };
                        }

                        NewJsonResultDup[0] = { BuId: -1, BuName: "Risk Areas/Business Unit", CalcRiskLevel: "", CalcRiskLevelCss: "", OverriddenRiskLevel: "", OverriddenRiskLevelCss: "", FinalRiskLevel: "", FinalRiskLevelCss: "", RiskAreas: NewAreaObjDup };

                        for (var i = 0; i < jsonResult.length; i++) {
                            NewJsonResultDup[i + 1] = jsonResult[i];
                        }

                        var mappedAmlHeatMapDataDup = $.map(NewJsonResultDup, function (result) {
                            return new BusinessUnitModel(result);
                        })
                        ViewModel.AmlPredInhHeatMapDataDup(mappedAmlHeatMapDataDup);
                        FormatPredInhRows();
                        //
                    }
                    else if (jsonResult == null)
                        logger.logError('An error occurred while fetching Inherent Heat Map Data. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);

                    else {
                        logger.logError('No Inherent Heat Map data available for selected filter criteria.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    $('#PredInherentHeatMapDiv').show();

                    $("#innerdiv-actualheatmap").scroll(function () {
                        $("#innerdiv-predheatmap").scrollLeft($("#innerdiv-actualheatmap").scrollLeft())
                    });

                    $("#innerdiv-predheatmap").scroll(function () {
                        $("#innerdiv-actualheatmap").scrollLeft($("#innerdiv-predheatmap").scrollLeft())
                    });
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getInhHeatMapData() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }
        //------------------------------Method that shows the predictive heatmap ends here------------------------------------
        function FormatPredInhRows() {
            try {
                var NoOfRows = ViewModel.AmlPredInhRiskAreaList().length;
                var FinalRowIndex = (NoOfRows - 1);
                var OverrideRowIndex = (NoOfRows - 2);
                var CalcRowIndex = (NoOfRows - 3);
                $($($('#tblPredInhHeatMap tbody').find('tr').get(CalcRowIndex)).find('td').get(0)).addClass('label-info');
                $($($('#tblPredInhHeatMap tbody').find('tr').get(OverrideRowIndex)).find('td').get(0)).addClass('label-green ');
                $($($('#tblPredInhHeatMap tbody').find('tr').get(FinalRowIndex)).find('td').get(0)).addClass('label-info');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FormatInhRows() method in HeatMaps.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------Method that gets changed data in weightings starts here-------------------------------------------
        function GetWeightingsComparissionDetails() {
            try {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Visualization/GetWeightingsDetails?ProfileId=" + ViewModel.SelectedProfileOfAssessment() + "&RiskAreaType=" + ViewModel.AssesmentType() + "&Type=BOTH",
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json',
                        data: JSON.stringify($.map(ViewModel.SelectedBuUnitsID(), function (result) {
                            return { BuId: result };
                        }))
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in GetWeightingsComparissionDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            if (jsonResult.length == 0) {
                                $('#WeightingsListDiv').show();
                                tableObj = $('#tblWeightingsReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblWeightingsReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.WeightingsComparissionList([]);
                                QuestionTableObj = $('#tblWeightingsReportDetails').DataTable({
                                    "aoColumnDefs": [{
                                        "aTargets": [1],
                                        "bVisible": true,
                                        "bSortable": true

                                    }, {
                                        "aTargets": [2],
                                        "bVisible": true,
                                        //"bSortable": false

                                    },
                                    {
                                        "aTargets": [3],
                                        "bSortable": true
                                    },
                                    {
                                        "aTargets": [4],
                                        "bSortable": true
                                    }]

                                });

                                $('#tblWeightingsReportDetails').DataTable().draw(false);
                            }
                            else {

                                $('#WeightingsListDiv').show();
                                var MappedWeightingsDetails = $.map(jsonResult, function (result) {
                                    return new WeightingsComparissionModel(result);
                                });



                                tableObj = $('#tblWeightingsReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblWeightingsReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.WeightingsComparissionList([]);
                                ViewModel.WeightingsComparissionList(MappedWeightingsDetails);
                                var ChangedWTBusinessUnits = ko.dependentObservable(function () {
                                    var types = ko.utils.arrayMap(ViewModel.WeightingsComparissionList(), function (item) { return item.BuName() })
                                    return ko.utils.arrayGetDistinctValues(types).sort();
                                });
                                for (var i = 0; i < ChangedWTBusinessUnits().length; i++) {
                                    ViewModel.ChangedWTBusinessUnits.push(ChangedWTBusinessUnits()[i])
                                }
                                QuestionTableObj = $('#tblWeightingsReportDetails').DataTable({
                                    "aoColumnDefs": [{
                                        "aTargets": [1],
                                        "bVisible": true,
                                        "bSortable": true

                                    }, {
                                        "aTargets": [2],
                                        "bVisible": true,
                                        //"bSortable": false

                                    },
                                    {
                                        "aTargets": [3],
                                        "bSortable": true
                                    },
                                    {
                                        "aTargets": [4],
                                        "bSortable": true
                                    }]

                                });

                                $('#tblWeightingsReportDetails').DataTable().draw(false);
                            }

                            GetThresholdsComparissionDetails(); ///Remove this. Just for testing.
                        }
                        else
                            logger.logError('Some Error Occured while Weightings', 'Error', system.getModuleId(ViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetWeightingsComparissionDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------Method that gets changed data in weightings ends here---------------------------------------------


        //------------------------------Method that gets changed data in Thresholds starts here-------------------------------------------
        function GetThresholdsComparissionDetails() {
            try {
                try {
                    return $.ajax({
                        url: "/api/Visualization/GetThresholdsDetails?ProfileId=" + ViewModel.SelectedProfileOfAssessment() + "&RiskAreaType=" + ViewModel.AssesmentType(),
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in GetThresholdsComparissionDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            ConstructDynamicHTML(jsonResult);
                        }
                        else
                            logger.logError('Some Error Occured while Fetching Active Roles', 'Error', system.getModuleId(ViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetThresholdsComparissionDetails() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdsComparissionDetails() method in InherentHeatMapAnalysis.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdsComparissionDetails() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetThresholdsComparissionDetails() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        //------------------------------Method that gets changed data in weightings ends here---------------------------------------------

        //-----------------------------Method that binds Dynamichtml for the thresholds comparrision starts here-----------------------------------------------------
        function ConstructDynamicHTML(jsonResult) {
            var DynamicHTML = "";
            DynamicHTML = '<div class="panel-collapse collapse in">' +
                '<div id="ThreshQuanComparisionTableDiv" class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-top-9">' +
                '<table id="tblThresholdsDetails" class="dataTable table-bordered no-footer" cellspacing="0">' +
                '<thead>' +
                '<tr>' +

                '<th class="site_name column-13">Risk Area Name</th>' +
                '<th class="site_name column-10">Risk Factor Name</th>' +
                '<th class="site_name column-10">Level/Score</th>';
            for (var i = 0; i < parseInt(jsonResult[0].LevelCount); i++) {
                DynamicHTML += '<th class="site_name column-10">Max % for Risk Score of ' + (i + 1) + '</th>';
            }
            if (jsonResult[0].FinalRiskLevel == null) {
                DynamicHTML += '</tr>  </thead> <tbody>';
            }
            else {


                DynamicHTML += '</tr>  </thead> <tbody>';
                for (var i = 0; i < jsonResult.length; i++) {
                    DynamicHTML += '<td>' + jsonResult[i].RiskAreaName + '</td>' +
                        '<td>' + jsonResult[i].RiskFactorName + '</td>' +
                        '<td class=' + jsonResult[i].CSS + '>' + jsonResult[i].FinalRiskLevel + '</td>';
                    for (var j = 0; j < jsonResult[i].ThresholdObjectlist.length; j++) {
                        if (jsonResult[i].ThresholdObjectlist[j].TV == jsonResult[i].ThresholdObjectlist[j].TE)
                            DynamicHTML += '<td>' + jsonResult[i].ThresholdObjectlist[j].TE + ' ? ' + jsonResult[i].ThresholdObjectlist[j].TV + '</td>';
                        else
                            DynamicHTML += '<td class="heatmap-null">' + jsonResult[i].ThresholdObjectlist[j].TE + ' ? ' + jsonResult[i].ThresholdObjectlist[j].TV + '</td>';
                    }
                    DynamicHTML += '</tr>'
                }
            }
            DynamicHTML += '</tbody></table></div></div>'
            document.getElementById('QuanThresholds').innerHTML = " ";
            document.getElementById('QuanThresholds').innerHTML = DynamicHTML;
            QuestionTableObj = $('#tblThresholdsDetails').DataTable({
                "aoColumnDefs": [{
                    "aTargets": [1],
                    "bVisible": true,
                    "bSortable": true

                }, {
                    "aTargets": [2],
                    "bVisible": true,
                    //"bSortable": false

                },
                {
                    "aTargets": [3],
                    "bSortable": true
                },
                {
                    "aTargets": [4],
                    "bSortable": true
                }]

            });
            $('#Thresholdsdiv').show();
            $('#QuanThresholds').show();

        }

        function GetRiskScoresComparissionDetails() {
            try {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Visualization/GetRiskScoresDetails?ProfileId=" + ViewModel.SelectedProfileOfAssessment() + "&AssessmentType=" + ViewModel.AssesmentType(),
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json'
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in GetWeightingsComparissionDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            if (jsonResult.length == 0) {
                                $('#RiskScoresListDiv').show();
                                tableObj = $('#tblRiskScoresReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblRiskScoresReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.RiskScoresComparissionList([]);
                                QuestionTableObj = $('#tblRiskScoresReportDetails').DataTable();

                                $('#tblRiskScoresReportDetails').DataTable().draw(false);
                            }
                            else {

                                $('#RiskScoresListDiv').show();
                                var MappedRiskScoresDetails = $.map(jsonResult, function (result) {
                                    return new RiskScoresComparissionModel(result);
                                });



                                tableObj = $('#tblRiskScoresReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblRiskScoresReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.RiskScoresComparissionList([]);
                                ViewModel.RiskScoresComparissionList(MappedRiskScoresDetails);
                                //var ChangedWTBusinessUnits = ko.dependentObservable(function () {
                                //    var types = ko.utils.arrayMap(ViewModel.WeightingsComparissionList(), function (item) { return item.BuName() })
                                //    return ko.utils.arrayGetDistinctValues(types).sort();
                                //});
                                //for (var i = 0; i < ChangedWTBusinessUnits().length; i++) {
                                //    ViewModel.ChangedWTBusinessUnits.push(ChangedWTBusinessUnits()[i])
                                //}
                                QuestionTableObj = $('#tblRiskScoresReportDetails').DataTable({
                                    "aoColumnDefs": [{
                                        "aTargets": [1],
                                        "bVisible": true,
                                        "bSortable": true

                                    }, {
                                        "aTargets": [2],
                                        "bVisible": true,
                                        //"bSortable": false

                                    },
                                    {
                                        "aTargets": [3],
                                        "bSortable": true
                                    },
                                    {
                                        "aTargets": [4],
                                        "bSortable": true
                                    }]

                                });

                                $('#tblRiskScoresReportDetails').DataTable().draw(false);
                            }


                        }
                        else
                            logger.logError('Some Error Occured while Weightings', 'Error', system.getModuleId(ViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetWeightingsComparissionDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function GetQualThresholdsComparisonDetails() {
            try {
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/Visualization/GetQualThresholdsComparisonDetails?ProfileId=" + ViewModel.SelectedProfileOfAssessment() + "&AssessmentType=" + ViewModel.AssesmentType(),
                        type: "GET",
                        headers: headers

                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in GetWeightingsComparissionDetails() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            if (jsonResult.length == 0) {
                                //  $('#RiskScoresListDiv').show();
                                tableObj = $('#tblQualThresholdsReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblQualThresholdsReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.QualThresholdsComparisonList([]);
                                QuestionTableObj = $('#tblQualThresholdsReportDetails').DataTable();

                                $('#tblQualThresholdsReportDetails').DataTable().draw(false);
                            }
                            else {

                                //$('#RiskScoresListDiv').show();
                                var MappedQualThresholdsDetails = $.map(jsonResult, function (result) {
                                    return new QualThresholdsComparisonModel(result);
                                });



                                tableObj = $('#tblQualThresholdsReportDetails').DataTable();
                                tableObj.destroy();
                                $('#tblQualThresholdsReportDetails tbody tr').remove();
                                QuestionTableObj = undefined;
                                ViewModel.QualThresholdsComparisonList([]);
                                ViewModel.QualThresholdsComparisonList(MappedQualThresholdsDetails);

                                QuestionTableObj = $('#tblQualThresholdsReportDetails').DataTable();

                                $('#tblQualThresholdsReportDetails').DataTable().draw(false);
                            }


                        }
                        else
                            logger.logError('Some Error Occured while Weightings', 'Error', system.getModuleId(ViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage(
                                //"You have been logged out. Please login again to complete the operation."
                                ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                                , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, {
                                    buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                                })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightingsComparissionDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetWeightingsComparissionDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }


        function GetSubAreaFlag() {
            try {
                ViewModel.SubAreaFlag(0);
                return $.ajax({
                    url: "/api/Visualization/GetSubAreaFlag?AssessmentProfile=" + ViewModel.SelectedProfileOfAssessment(),
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetCurrentProfileOfAssessment() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        ViewModel.SubAreaFlag(jsonResult[0].Parent_Flag)
                        //var MappedList = $.map(jsonResult, function (result) {
                        //    var SubAreaModelObj = new SubAreaModel(result);
                        //    return SubAreaModelObj;
                        //});

                        //  ViewModel.SubAreaFlag(MappedList);
                    }
                    else {
                        logger.logError('An error occurred while fetching the current Year of Assessment. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetCurrentYearOfAssessment() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(
                            //"You have been logged out. Please login again to complete the operation."
                            ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name())
                            , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name()), [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllYearsOfAssessment() method in InherentHeatMapAnalysis.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetCurrentYearOfAssessment() method in InherentHeatMapAnalysis.js';
                    logger.logMessage(msg);
                }
            }
        }


        //-----------------------------Method that  binds Dynamichtml for the thresholds comparission starts here----------------------------------------------------
        //--------------------------------------------Model Defination Starts Here..............................................................//
        function BusinessUnitFilterModel(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable(item.BuId);
                self.BusinessUnitName = ko.observable(item.BuName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitFilterModel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function BusinessUnitsModel(item) {
            try {
                var self = this;
                self.BusinessUnit_ID = ko.observable(item.BuId);
                self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuName).text());
                self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.TargetRow = ko.observable();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        };



        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable(item.BuId);
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.CalculatedRiskLevel = ko.observable($('<div/>').html(item.CalcRiskLevel).text());
                self.CalculatedRiskLevelCss = ko.observable($('<div/>').html(item.CalcRiskLevelCss).text());
                self.OverriddenRiskLevel = ko.observable($('<div/>').html(item.OverriddenRiskLevel).text());
                self.OverriddenRiskLevelCss = ko.observable($('<div/>').html(item.OverriddenRiskLevelCss).text());
                self.FinalRiskLevel = ko.observable($('<div/>').html(item.FinalRiskLevel).text());
                self.FinalRiskLevelCss = ko.observable($('<div/>').html(item.FinalRiskLevelCss).text());
                var mappedRiskAreaList = $.map(item.RiskAreas, function (result) {
                    return new AreaModel(result);
                })
                if (item.RiskAreas[0].RaName == item.RiskAreas[0].RiskLevel && (item.RiskAreas[0].RiskLevelCss == "" || item.RiskAreas[0].RiskLevelCss == undefined)) {
                    mappedRiskAreaList.push(new AreaModel({ RaId: -1, RaName: "Calculated Risk Level", RiskLevel: "Calculated Risk Level", Css: "" }));
                    mappedRiskAreaList.push(new AreaModel({ RaId: -2, RaName: "Overridden Risk Level", RiskLevel: "Overridden Risk Level", Css: "" }));
                    mappedRiskAreaList.push(new AreaModel({ RaId: -3, RaName: "Final Risk Level", RiskLevel: "Final Risk Level", Css: "" }));
                }
                else {
                    mappedRiskAreaList.push(new AreaModel({ RaId: -1, RaName: "Calculated Risk Level", RiskLevel: item.CalcRiskLevel, Css: item.CalcRiskLevelCss }));
                    mappedRiskAreaList.push(new AreaModel({ RaId: -2, RaName: "Overridden Risk Level", RiskLevel: item.OverriddenRiskLevel, Css: item.OverriddenRiskLevelCss }));
                    mappedRiskAreaList.push(new AreaModel({ RaId: -3, RaName: "Final Risk Level", RiskLevel: item.FinalRiskLevel, Css: item.FinalRiskLevelCss }));
                }
                self.AreaList = ko.observableArray(mappedRiskAreaList);
            }
            catch (e) {
                var msg = 'exception' + e + 'source: BusinessUnitModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function AreaModel(item) {
            try {
                var self = this;
                self.AreaId = ko.observable(item.RaId);
                self.AreaName = ko.observable($('<div/>').html(item.RaName).text());
                self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
                self.RiskLevelCss = ko.observable($('<div/>').html(item.Css).text());
            }
            catch (e) {
                var msg = 'exception' + e + 'source: AreaModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function WeightingsComparissionModel(item) {
            try {
                var self = this;
                self.Id = ko.observable(item.Id);
                self.BuName = ko.observable(item.Bu_Name);
                self.AFName = ko.observable(item.Name);
                self.Type = ko.observable(item.Type);
                self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.ExistingWeightings = ko.observable(item.ExistingWeightings);
                self.ProposedWeightings = ko.observable(item.ProposedWeightings);

            }
            catch (e) {
                var msg = 'exception' + e + 'source: WeightingsComparissionModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function RiskScoresComparissionModel(item) {
            try {
                var self = this;
                self.RiskAreaName = ko.observable(item.RiskAreaName);
                self.RiskFactorName = ko.observable(item.RiskFactorName);
                self.SubFactorName = ko.observable(item.SubFactorName);
                self.Response = ko.observable($('<div/>').html(item.Response).text());
                self.ExistingRiskScore = ko.observable(item.ExistingRiskScore);
                self.ProposedRiskScore = ko.observable(item.ProposedRiskScore);
                self.SubAreaName = ko.observable(item.SubAreaName);

            }
            catch (e) {
                var msg = 'exception' + e + 'source: WeightingsComparissionModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function QualThresholdsComparisonModel(item) {
            try {
                var self = this;
                self.RiskAreaName = ko.observable(item.RiskAreaName);
                self.RiskFactorName = ko.observable(item.RiskFactorName);
                self.Level = ko.observable(item.Level);
                self.ExistingMinimum = ko.observable(item.ExistingMinimum);
                self.ProposedMinimum = ko.observable(item.ProposedMinimum);
                self.ExistingMaximum = ko.observable(item.ExistingMaximum);
                self.ProposedMaximum = ko.observable(item.ProposedMaximum);
                self.MinCSS = ko.observable(item.MinCSS);
                self.MaxCSS = ko.observable(item.MaxCSS);
                self.CSS = ko.observable(item.CSS);
            }
            catch (e) {
                var msg = 'exception' + e + 'source: WeightingsComparissionModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function ThresholdsComparissionModel(item) {
            try {
                var self = this;
                self.SNo = ko.observable(item.SNo);
                self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
                self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
                self.FinalRiskLevel = ko.observable($('<div/>').html(item.FinalRiskLevel).text());
                self.CSS = ko.observable($('<div/>').html(item.CSS).text());
                self.TV_1 = ko.observable(item.TV_1);
                self.TV_2 = ko.observable(item.TV_2);
                self.TV_3 = ko.observable(item.TV_3);
                self.TV_4 = ko.observable(item.TV_4);
                self.TV_5 = ko.observable(item.TV_5);
                self.TE_1 = ko.observable(item.TE_1);
                self.TE_2 = ko.observable(item.TE_2);
                self.TE_3 = ko.observable(item.TE_3);
                self.TE_4 = ko.observable(item.TE_4);
                self.TE_5 = ko.observable(item.TE_5);
                if (self.TV_1() != self.TE_1()) {
                    self.TVCSS_1 = ko.observable('heatmap-null')
                }
                else {
                    self.TVCSS_1 = ko.observable('')
                }
                if (self.TV_2() != self.TE_2()) {
                    self.TVCSS_2 = ko.observable('heatmap-null')
                }
                else {
                    self.TVCSS_2 = ko.observable('')
                }
                if (self.TV_3() != self.TE_3()) {
                    self.TVCSS_3 = ko.observable('heatmap-null')
                }
                else {
                    self.TVCSS_3 = ko.observable('')
                }
                if (self.TV_4() != self.TE_4()) {
                    self.TVCSS_4 = ko.observable('heatmap-null')
                }
                else {
                    self.TVCSS_4 = ko.observable('')
                }
                if (self.TV_5() != self.TE_5()) {
                    self.TVCSS_5 = ko.observable('heatmap-null')
                }
                else {
                    self.TVCSS_5 = ko.observable('')
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source: ThresholdsComparissionModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        //Model to Store the Profileofassessmentdetails
        function ProfileofAssessmentModel(item) {
            try {
                var self = this;
                self.ConfigurationFreezeFlag = ko.observable('true');
                self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
                self.Todate = ko.observable($('<div/>').html(item.Todate).text());
                self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
                self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }
        function AssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                self.AssessmentName = ko.observable(item.AssessmentName);
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function ScenarioModel(item) {
            try {
                var self = this;
                self.ScenarioId = ko.observable($('<div/>').html(item.ScenarioId).text());
                self.ScenarioOrder = ko.observable($('<div/>').html(item.ScenarioOrder).text());
                self.ScenarioName = ko.observable($('<div/>').html(item.ScenarioName).text());
                self.ScenarioDescription = ko.observable($('<div/>').html(item.ScenarioDescription).text());
                self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
                self.AssessmentTypeName = ko.observable($('<div/>').html(item.AssessmentTypeName).text());
                self.LastModifiedDate = ko.observable($('<div/>').html(item.LastModifiedDate).text());
                self.RunDate = ko.observable($('<div/>').html(item.RunDate).text());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ScenarioModel() method in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;

                self.BusinessLevelId = ko.observable($('<div/>').html(item.BuLId).text());
                self.BusinessLevelName = ko.observable($('<div/>').html(item.BuLevelName).text());

            } catch (e) {
                var msg = 'exception' + e + 'source:BusinessLevelModel() in InherentHeatMapAnalysis.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

    });


